// tslint:disable
export const logo: string = require('./logo.png');
